// =====================================================================================================================
// ========== IMPORTS
// =====================================================================================================================

import React, { useState } from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid2"
import LeasesForm from "./LeasesForm"
import LeasesTable from "./LeasesTable"

// =====================================================================================================================
// ========== LEASES PAGE
//
// Rationale: this component is intentionally kept minimal — it owns only the `selectedLeaseId` piece of UI state
// that must be shared between the form (to know what to edit) and the table (to control the row highlight).
// All data-fetching and mutation logic lives inside LeasesForm and LeasesTable respectively.
// `supabase` is the only external dependency; the old `database` / `settings` props are gone.
// =====================================================================================================================

export default function Leases({ supabase }) {

    const [selectedLeaseId, setSelectedLeaseId] = useState(null)

    // Called by the form after a successful insert or delete so the table clears its selection.
    const handleFormSuccess = () => setSelectedLeaseId(null)

    return (
        <Box sx={{ width: "100%" }}>
            <Grid container spacing={4}>

                {/* ── FORM ── */}
                <Grid size={{ xs: 12, lg: 4 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        {selectedLeaseId ? "Modifier un bail" : "Ajouter un bail"}
                    </Typography>
                    <LeasesForm
                        supabase={supabase}
                        selectedLeaseId={selectedLeaseId}
                        onSuccess={handleFormSuccess}
                    />
                </Grid>

                {/* ── TABLE ── */}
                <Grid size={{ xs: 12, lg: 8 }}>
                    <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
                        Liste des baux
                    </Typography>
                    <LeasesTable
                        supabase={supabase}
                        selectedLeaseId={selectedLeaseId}
                        onSelect={setSelectedLeaseId}
                    />
                </Grid>

            </Grid>
        </Box>
    )
}